import api from "./client";

export async function listSalesOrders(params = {}) {
  const res = await api.get("/sales-orders", { params });
  return res.data.data.items;
}

export async function listSalesOrdersPaged(params = {}) {
  const res = await api.get("/sales-orders", { params });
  return res.data.data;
}

export async function createSalesOrder(payload) {
  const res = await api.post("/sales-orders", payload);
  return res.data.data; // { id }
}

export async function getSalesOrder(id) {
  const res = await api.get(`/sales-orders/${id}`);
  return res.data.data; // order + items
}

export async function createSalesOrderItem(salesOrderId, payload) {
  const res = await api.post(`/sales-orders/${salesOrderId}/items`, payload);
  return res.data.data; // { id }
}

export async function updateSalesOrderItem(salesOrderId, itemId, payload) {
  const res = await api.put(`/sales-orders/${salesOrderId}/items/${itemId}`, payload);
  return res.data.data;
}

export async function getSalesOrderItemAudit(salesOrderId, itemId) {
  const res = await api.get(`/sales-orders/${salesOrderId}/items/${itemId}/audit`);
  return res.data.data;
}

export async function cancelSalesOrderItem(salesOrderId, itemId) {
  const res = await api.delete(`/sales-orders/${salesOrderId}/items/${itemId}`);
  return res.data.data;
}

export async function createProductionOrderFromSalesItem(payload) {
  const res = await api.post(`/production-orders/from-sales-item`, payload);
  return res.data.data; // { id }
}

export async function cancelSalesOrder(id) {
  const res = await api.delete(`/sales-orders/${id}`);
  return res.data.data;
}

export async function deleteSalesOrder(id) {
  const res = await api.delete(`/sales-orders/${id}/hard`);
  return res.data.data;
}

export async function importSalesOrders(payload) {
  const res = await api.post(`/sales-orders/import`, payload);
  return res.data.data; // { created, ids, errors }
}

